import type { PresentationModule } from '../../presentation/types';
import { closing } from './content';
import { ClosingScene } from './scenes/ClosingScene';

export const closingModule: PresentationModule = {
  id: 'closing',
  label: 'Closing',
  priority: 'structural',
  scenes: [
    { ...closing, module: 'closing', create: (resolved) => new ClosingScene(resolved) },
  ],
};
